import { render } from "./ArchiveOffOutline.vue?vue&type=template&id=71f9c6ab"
import script from "./ArchiveOffOutline.vue?vue&type=script&lang=js"
export * from "./ArchiveOffOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__